import '../assets/styles/globals.css'
import 'react-responsive-carousel/lib/styles/carousel.min.css' // requires a loader

export { App as default } from '../views/pages/_app'
